module.exports = __webpack_public_path__ + "stylesheets/video-folder-bottom_3dee4ebb64472d66338320e123655759.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/folder/video-folder-bottom.less
// module id = Cw72
// module chunks = 153